import script from "./Notification.vue?vue&type=script&setup=true&lang=js"
export * from "./Notification.vue?vue&type=script&setup=true&lang=js"

import "./Notification.vue?vue&type=style&index=0&id=8a7ae5aa&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./Notification.vue?vue&type=custom&index=0&blockType=spec&lang=md"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a7ae5aa"]])

export default __exports__